import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DtDashboardService {
  constructor(private http: HttpClient) {}

  getDashboardData(data:any): Observable<any> {
    // const url = environment.baseUrl + '/dashboard/get-dashboard/';
    const url = environment.baseUrl + '/dashboard/get-dashboard-dt';
    return this.http.post(url, data);
  }
}
